import * as React from "react";
import * as ReactDOM from "react-dom/client";

import "./index.css";
import App from "./App";

import * as Sentry from "@sentry/react";
import { SettingProvider } from "./contexts/SettingContextProvider";

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://b720f56e49ab36cd2015932676395dce@o4508977290215424.ingest.us.sentry.io/4508977291395072",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <SettingProvider>
      <App />
    </SettingProvider>
  </React.StrictMode>,
);
